import React, { useMemo } from 'react'

import MathJax from 'react-mathjax2'
import { Container } from './styled'
import { Unit } from './types'

interface Props {
    upperUnits: Unit[]
    lowerUnits?: Unit[]
}

export default function MeasurementUnitFormatter({ upperUnits, lowerUnits }: Props) {
    const buildDisplayablePower = (powerValue: number) => {
        powerValue = Math.abs(powerValue)

        if (powerValue === 1 || powerValue === 0) return ''
        //if (powerValue < 1) return `1/${Math.round(1 / powerValue).toFixed(0)}`
        return powerValue.toFixed(0)
    }

    const concatenateSingleExpression = (expression: string, unit: Unit) => {
        const e = `${unit.name}^{${buildDisplayablePower(unit.power)}}`

        return expression ? `${expression} \\ ${e}` : e
    }

    const buildSimpleExpression = (units: Unit[]) => {
        let positivePowerExpression = ``
        let negativePowerExpression = ``

        if (units && units.length) {
            for (const unit of units) {
                if (unit.power >= 0) {
                    positivePowerExpression = concatenateSingleExpression(positivePowerExpression, unit)
                } else {
                    negativePowerExpression = concatenateSingleExpression(negativePowerExpression, unit)
                }
            }
        }

        return negativePowerExpression
            ? `{${positivePowerExpression}}\\over{${negativePowerExpression}}`
            : positivePowerExpression
    }
    const buildCompositeExpression = (expressionList: string[]) => {
        return expressionList.reduce((acc, curr) => {
            acc = acc ? `${acc}\\over{${curr}}` : `{${curr}}`
            return acc
        }, ``)
    }

    const expression = useMemo(() => {
        const upperExpression = buildSimpleExpression(upperUnits)
        const lowerExpression = buildSimpleExpression(lowerUnits)

        return lowerExpression ? buildCompositeExpression([upperExpression, lowerExpression]) : upperExpression
    }, [upperUnits, lowerUnits])

    return (
        <Container className="unit-container">
            <MathJax.Node inline>{expression}</MathJax.Node>
        </Container>
    )
}
export function MeasurementUnitFormatterProvider({ children }) {
    return (
        <MathJax.Context input={`tex`}>
            <>
                {/* DON`T REMOVE THESE LINES */}
                <div style={{ display: 'none' }}>
                    <MathJax.Node>{``}</MathJax.Node>
                </div>
                <>{children}</>
            </>
        </MathJax.Context>
    )
}
